import { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../contexts/AuthContext';
import { Button, Modal, theme } from 'antd';
import { LogoutOutlined } from '@ant-design/icons';
import AppTheme from '../theme/AppTheme';

function LogoutDialogContent({ open, onClose, onConfirm }) {
  const { token } = theme.useToken();
  return (
    <Modal
      open={open}
      onCancel={onClose}
      title="Log out of Uzdpart360?"
      centered
      width={400}
      style={{ maxWidth: 'calc(100vw - 48px)' }}
      footer={[
        <Button key="cancel" onClick={onClose} autoFocus>Stay signed in</Button>,
        <Button key="confirm" danger type="primary" icon={<LogoutOutlined />} onClick={onConfirm}>Log out</Button>,
      ]}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: 16, padding: '12px 0 20px' }}>
        <span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, flexShrink: 0, borderRadius: 14, background: token.colorErrorBg, color: token.colorError, fontSize: 24 }}><LogoutOutlined aria-hidden="true" /></span>
        <div style={{ color: token.colorTextSecondary, lineHeight: 1.6 }}>You’ll be signed out on this browser. Your saved drafts and queued messages stay with your account.</div>
      </div>
    </Modal>
  );
}

export function LogoutDialogComponent(props) {
  return <AppTheme><LogoutDialogContent {...props} /></AppTheme>;
}

const useLogout = () => {
  const navigate = useNavigate();
  const { logout } = useContext(AuthContext);
  const [openDialogue, setOpenDialogue] = useState(false);

  const handledialogueOpen = () => setOpenDialogue(true);
  const handledialogueClose = () => setOpenDialogue(false);

  const logout_now = async () => {
    await logout();
    setOpenDialogue(false);
    navigate('/');
  };

  const LogoutDialog = (
    <LogoutDialogComponent
      open={openDialogue}
      onClose={handledialogueClose}
      onConfirm={logout_now}
    />
  );

  return {
    handledialogueOpen,
    LogoutDialog,
  };
};

export default useLogout;
